import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {compose} from 'shared/utils/compose';
import {toReadable} from 'shared/utils/number';
import {useAnalytics} from 'ui/adapters/Analytics';
import {RedistributeSaved, RedistributeProps} from 'ui/adapters/Core';
import {Button, SectionConstraints} from 'components/Button';
import {Option} from './style';

export const RedistributeOption = (): ReactElement => {
  const registerRedistribute = useAnalytics(EventKind.RedistributeSaved);

  return (
    <RedistributeSaved>
      {({oldAmount, newAmount, onSelectOption}: RedistributeProps) =>
        newAmount > 0 && (
          <Option data-test='option' data-option='redistribute'>
            <SectionConstraints>
              <Button color='yellow' onPress={compose(onSelectOption, registerRedistribute)}>
                Увеличить дневной бюджет
              </Button>
            </SectionConstraints>
            {oldAmount === newAmount ? (
              'Почти ничего не изменится :–('
            ) : (
              <>
                Получится <span data-test='new'>{toReadable(newAmount)}</span> вместо{' '}
                <span data-test='old'>{toReadable(oldAmount)}</span> в день
              </>
            )}
          </Option>
        )
      }
    </RedistributeSaved>
  );
};
